import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface HomeCSSStyle extends CRBTUICSSStyle
{
    getBannerCSSStyle(): object;
    getFeaturedCategoryCSSStyle(): object;
    getCategoriesCSSStyle(): object;
    getLogoCSSStyle():object;
    getMobileLogoCSSStyle():object;
    getNameTuneMainDivCSSStyle():object;
    getNameTuneDivCSSStyle():object;
    getNameTuneLabelCSSStyle():object;
    getNameTuneSearchDivCSSStyle():object;
}

export class HomeCSSStyleImpl extends CRBTUICSSStyleImpl implements HomeCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: '100%', 
            width: '100%',
            // display: "flex",
        };
    }
  getLogoCSSStyle():object{
      return{

      height: "auto",  width:"100%", display: "flex", flexFlow: "row wrap",
      };
  }

  getMobileLogoCSSStyle():object{
    return{

    height: "auto",  width:"100%", display: "flex", flexFlow: "row wrap",
    };
}
    getInnerCSSStyle(): object 
    {
        return {
            height: '100%', 
            width: '100%', 
            marginBottom: "100px",
        };
    }

    getBannerCSSStyle(): object 
    {
        return {
            height: '300px', 
            width: '100%',  
        };
    }

    getFeaturedCategoryCSSStyle(): object 
    {
        return {
            height: '300px', 
            width: '100%',  
        };
    }

    getCategoriesCSSStyle(): object 
    {
        return {
            height: '300px', 
            width: '100%',  
        };
    }

    getNameTuneMainDivCSSStyle():object
    {
        return{
            width:"100%",height:"auto", display:"inline",flexFlow:"row wrap"
        };
    }

    getNameTuneDivCSSStyle():object
    {
        return{
            width:'100%', 
            height:'156px',
            marginTop:'25px',
            paddingTop:"32px",
            paddingBottom:'32px',
            display: "flex", 
            flexFlow: "row wrap", 
            backgroundColor:this.getContext().getResources().getColor(Colors.color_3),
            backgroundSize: "cover",
        };
    }
    getNameTuneLabelCSSStyle():object
    {
        return{
            width:'100%',
            // paddingLeft:'75px',
            // paddingTop:'32px', 
            height:'28px', 
            lineHeight:'28px',
            fontFamily:this.getResources().getFontFamily(),
            fontStyle:"bold",
            fontWeight:900,
            fontSize:'24px',
            color:this.getContext().getResources().getColor(Colors.color_4),
            textAlign:'center'
        };
    }

    getNameTuneSearchDivCSSStyle():object
    {
        return{
            marginTop:'0px',
            width:'60%',
            height:'48px',
            marginLeft:'auto',
            marginRight:"auto", 
            fontFamily:this.getResources().getFontFamily(),
            // paddingBottom: '32px'
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homecss.tsx